/*
 * Module for the State Withholding Election form
*/
rs.module("content/communications/onlineforms/statewithholdingelection/index",

    [ "common/select-helper" ],

    function (selectHelper) {

        //
        // Initialize
        //
        function initialize(jsSelectors) {

            var form = $.js(jsSelectors.form);
            var filingStatusSelect = form.js(jsSelectors.filingStatusSelect);
            var allowancesTextBox = form.js(jsSelectors.allowancesTextBox);
            var extraAmountTextBox = form.js(jsSelectors.extraAmountTextBox);
            var noWithholdingCheckbox = form.js(jsSelectors.noWithholdingCheckbox);

            // Get select helper for filingStatusSelect
            var filingStatusSelectHelper = selectHelper.getHelper(filingStatusSelect);

            // enable/disable form fields based on the checkbox
            noWithholdingCheckbox.change(function () {

                var noWithholding = noWithholdingCheckbox.is(":checked");

                filingStatusSelectHelper.setDisabled(noWithholding);
                allowancesTextBox.prop("disabled", noWithholding);
                extraAmountTextBox.prop("disabled", noWithholding);

                if (noWithholding) {
                    filingStatusSelectHelper.setValue(null);
                    filingStatusSelect.clearErrors();
                    allowancesTextBox.val("").clearErrors();
                    extraAmountTextBox.val("").clearErrors();
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);